import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import UploadFasta from "@presentation/components/fasta/UploadFasta";
import { FastaFile } from "@domain/schemas/BI";

export const UploadFastaDialog: React.FC<{
  onUploadSuccess: (uploadedFasta: FastaFile) => void;
  onCancel: () => void;
}> = ({ onUploadSuccess, onCancel }) => {
  return (
    <Dialog title="Upload Fasta" onClose={onCancel} width={600}>
      <UploadFasta onUploadSuccess={onUploadSuccess} />
      <DialogActionsBar>
        <Button type="button" aria-label="Close upload dialog" onClick={onCancel}>
          Close
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};
